import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';

import { AppData } from 'src/app/data';
import { LocationService } from '../../services/location.service';
import { ModalController, IonicModule } from '@ionic/angular';
import { IncrementalControlComponent } from '../../components/increment-control/increment-control.component';
import { FormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-adjust-odometer',
  templateUrl: './adjust-odometer.page.html',
  styleUrls: ['./adjust-odometer.page.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [IonicModule, IncrementalControlComponent, FormsModule, TranslatePipe],
})
export class AdjustOdometerPage implements OnInit {
  private readonly modalController = inject(ModalController);
  private readonly locationService = inject(LocationService);

  public readonly data = inject(AppData);

  suggestedOdometer: number;
  confirmedOdometer: number;

  private readonly gtm = (<any>window).dataLayer || [];

  async ngOnInit() {
    this.gtm.push({ event: 'custom_event', custom_event_name: 'view_ adjust_odometer' });
    this.suggestedOdometer = this.confirmedOdometer = this.data.gpsReport?.odometer || 0;
  }

  async submitClicked() {
    this.gtm.push({ event: 'custom_event', custom_event_name: 'click_ adjust_odometer' });
    await this.locationService.setOdometer(this.confirmedOdometer);
    await this.modalController.dismiss(this.confirmedOdometer, 'submit');
  }

  async dismissModal() {
    await this.modalController.dismiss(null, 'cancel');
  }
}
